import { useState } from 'react';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { Card, CardBody } from '@/shared/components/Card';
import AnalyticsTab from './tabs/AnalyticsTab';
import LeaderboardTab from './tabs/LeaderboardTab';
import UserManagementTab from './tabs/UserManagementTab';
import ReferredUsersTab from './tabs/ReferredUsersTab';
import WithdrawalsTab from './tabs/WithdrawalsTab';
import SettingsTab from './tabs/SettingsTab';
import AuditLogTab from './tabs/AuditLogTab';

/**
 * Top-level admin Referrals control panel. Tabbed view to keep the surface
 * area scoped: Leaderboard / Withdrawals / Settings / Audit log. Mirrors the
 * proposal §1.6 admin requirements.
 */
const Referrals = () => {
    const [tab, setTab] = useState<string>('analytics');
    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Referral Program</h3>
                    <h3 className="page-subhead subhead">Manage tier thresholds, commission rates, top referrers, withdrawals, and admin actions.</h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <Tabs id="referrals-tabs" activeKey={tab} onSelect={(k) => k && setTab(k)} className="mb-3">
                                <Tab eventKey="analytics" title="Analytics">
                                    {tab === 'analytics' && <AnalyticsTab />}
                                </Tab>
                                <Tab eventKey="leaderboard" title="Leaderboard">
                                    {tab === 'leaderboard' && <LeaderboardTab />}
                                </Tab>
                                <Tab eventKey="users" title="User management">
                                    {tab === 'users' && <UserManagementTab />}
                                </Tab>
                                <Tab eventKey="referred-users" title="Referred users">
                                    {tab === 'referred-users' && <ReferredUsersTab />}
                                </Tab>
                                <Tab eventKey="withdrawals" title="Withdrawals">
                                    {tab === 'withdrawals' && <WithdrawalsTab />}
                                </Tab>
                                <Tab eventKey="settings" title="Settings">
                                    {tab === 'settings' && <SettingsTab />}
                                </Tab>
                                <Tab eventKey="audit" title="Audit log">
                                    {tab === 'audit' && <AuditLogTab />}
                                </Tab>
                            </Tabs>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Referrals;
